// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"dc705371","977":"bb9aee11"}[chunkId] + ".chunk.js";
};